<template>
  <span class="objectid"><code
    tabindex="0"
    ref="code"
    :title="$t('Click to copy')"
    @click="copy"
  ><slot>{{value}}</slot></code></span>
</template>

<script>
  export default {
    name: 'objectid',
    props: {
      value: {},
      label: String,
    },
    methods: {
      copy () {
        let el = this.$refs.code.querySelector('[data-copy]') || this.$refs.code;
        if (document.selection) { // IE
          let range = document.body.createTextRange();
          range.moveToElementText(el);
          range.select();
        } else if (window.getSelection) {
          let range = document.createRange();
          range.selectNode(el);
          window.getSelection().removeAllRanges();
          window.getSelection().addRange(range);
        }
        document.execCommand('copy');
      },
    },
  };
</script>

<style scoped lang="scss">
  code {
    border        : 1px solid rgba(236, 62, 140, .5);
    padding       : 0 .2em;
    border-radius : 4px;
    cursor        : pointer;

    &:hover, &:active, &:focus {
      border : 1px solid rgb(236, 62, 140);
    }
  }

  .objectid {
    margin : 0 .5em;
  }
</style>



// WEBPACK FOOTER //
// src/vuestic-theme/vuestic-components/vuestic-objectid/objectid.vue